// extracted by mini-css-extract-plugin
module.exports = {"container":"ContentSurface_container__64JnU","header":"ContentSurface_header__2kCXk","title":"ContentSurface_title__AeCok","content":"ContentSurface_content__1Qzwt"};